export const selectorPaths = {
  project: {
    name: 'properties.name',
    description: 'properties.description',
    cover: 'enclosure.coverEdges[0].node',
    printedcircuitboard: 'content.edges[0].node',
    fastner: 'fastener'
  },
  printedcircuitboard: {
    width: 'content.edges[0].node.properties.width',
    length: 'content.edges[0].node.properties.length',
    thickness: 'content.edges[0].node.properties.thickness',
    componentSide: {
      height: 'content.edges[0].node.properties.componentSide.height',
      border: {
        top: 'content.edges[0].node.properties.componentSide.border.top',
        right: 'content.edges[0].node.properties.componentSide.border.right',
        bottom: 'content.edges[0].node.properties.componentSide.border.bottom',
        left: 'content.edges[0].node.properties.componentSide.border.left'
      }
    },
    solderSide: {
      height: 'content.edges[0].node.properties.solderSide.height',
      border: {
        top: 'content.edges[0].node.properties.solderSide.border.top',
        right: 'content.edges[0].node.properties.solderSide.border.right',
        bottom: 'content.edges[0].node.properties.solderSide.border.bottom',
        left: 'content.edges[0].node.properties.solderSide.border.left'
      }
    }
  },
  accessories: {
    fastener: 'accessories.fastenerEdges[0].node'
  },
  contentGaps: {
    top: 'content.edges[0].properties.gap.top',
    right: 'content.edges[0].properties.gap.right',
    bottom: 'content.edges[0].properties.gap.bottom',
    left: 'content.edges[0].properties.gap.left',
    front: 'content.edges[0].properties.gap.front',
    back: 'content.edges[0].properties.gap.back'
  },
  cover: {
    id: 'enclosure.coverEdges[0].node.id',
    color: 'enclosure.coverEdges[0].node.properties.color',
    plates: {
      front: {
        thickness: 'enclosure.coverEdges[0].node.plates.edges[4].properties.thickness',
        elements: 'enclosure.coverEdges[0].node.plates.edges[4].node.elements'
      },
      top: {
        thickness: 'enclosure.coverEdges[0].node.plates.edges[0].properties.thickness',
        elements: 'enclosure.coverEdges[0].node.plates.edges[0].node.elements'
      },
      right: {
        thickness: 'enclosure.coverEdges[0].node.plates.edges[1].properties.thickness',
        elements: 'enclosure.coverEdges[0].node.plates.edges[1].node.elements'
      },
      bottom: {
        thickness: 'enclosure.coverEdges[0].node.plates.edges[2].properties.thickness',
        elements: 'enclosure.coverEdges[0].node.plates.edges[2].node.elements'
      },
      left: {
        thickness: 'enclosure.coverEdges[0].node.plates.edges[3].properties.thickness',
        elements: 'enclosure.coverEdges[0].node.plates.edges[3].node.elements'
      },
      back: {
        thickness: 'enclosure.coverEdges[0].node.plates.edges[5].properties.thickness',
        elements: 'enclosure.coverEdges[0].node.plates.edges[5].node.elements'
      }
    }
  },
  adapter: {
    plates: {
      top: {
        thickness: 'enclosure.adapterEdges[0].node.plates.edges[0].properties.thickness'
      },
      bottom: {
        thickness: 'enclosure.adapterEdges[0].node.plates.edges[1].properties.thickness'
      }
    }
  },
  total: {}
}
